// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { RouterProvider } from 'react-router-dom'

import FullPageLoader from '@/app/shared/components/FullPageLoader'
import { setTokenRetriever } from '@/services/auth/token-provider'
import { router } from './router'

export default function App(): JSX.Element {
  const {
    isLoading,
    isAuthenticated,
    loginWithRedirect,
    getAccessTokenSilently,
  } = useAuth0()

  if (isAuthenticated) {
    setTokenRetriever(getAccessTokenSilently)
  }

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({ appState: { returnTo: window.location.pathname } })
    }
  }, [isLoading, loginWithRedirect, isAuthenticated])

  useEffect(() => {
    document.title = 'Tenant Cloud Configurator'
  })

  if (isLoading) {
    return <FullPageLoader />
  }

  if (!isAuthenticated) {
    return <FullPageLoader />
  }

  return <RouterProvider router={router} />
}
